import { render, staticRenderFns } from "./EditSubscriptionCategories.vue?vue&type=template&id=577f72fa"
import script from "./EditSubscriptionCategories.vue?vue&type=script&lang=ts"
export * from "./EditSubscriptionCategories.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports